import { useFormContext } from "react-hook-form";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  useFormField,
} from "@/components/ui/form";
import { Textarea, type TextareaProps } from "@/components/ui/textarea";

type Props = TextareaProps & {
  name: string;
  label?: string;
  autoFocus?: boolean;
  description?: string;
};

export const TextAreaInput = ({
  label,
  name,
  description,
  placeholder,
  ...rest
}: Props) => {
  const form = useFormContext();
  const { error } = useFormField();

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          {label && <FormLabel>{label}</FormLabel>}
          <FormControl>
            <Textarea
              placeholder={placeholder}
              {...field}
              {...rest}
              aria-invalid={error ? true : undefined}
            />
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
